import { useCallback, useEffect } from 'react';

const useEventListen = (
  name: string,
  onReceived: (e: Event) => void,
  oneTimeListen: boolean = false
) => {
  const onEventReceived = useCallback(
    (e: Event) => {
      onReceived(e);
      if (oneTimeListen) window.removeEventListener(name, onEventReceived);
    },
    [name, onReceived, oneTimeListen]
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener(name, onEventReceived);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener(name, onEventReceived);
      }
    };
  }, [name, onEventReceived]);
};

export default useEventListen;
